import { InterstitialContent } from '../../content.types';

const continueButton = {
  displayText: 'Continue',
  url: '/home',
  color: 'primary' as const,
};

export const appUnregisteredInterstitial: InterstitialContent = {
  name: 'app-unregistered',
  header: 'Welcome to Summer Health',
  body: 'You need to register to access the Summer Health app.',
  buttons: [
    {
      displayText: 'Register',
      url: '/signup/profile',
      color: 'primary',
    },
  ],
};

export const signupWelcomeInterstitial: InterstitialContent = {
  name: 'signup-welcome',
  header: 'Welcome to Summer Health',
  body: 'Get pediatric care for your child by texting our doctors.',
  buttons: [
    {
      displayText: 'Get started',
      url: '/signup/profile',
      color: 'primary',
    },
    {
      displayText: 'Log in',
      url: '/api/auth/login',
      color: 'secondary',
    },
  ],
};

export const signupWelcomeInviteInterstitial: InterstitialContent = {
  name: 'signup-welcome-invite',
  header: 'You’ve been invited to Summer Health',
  body: 'Accept the invitation to access your child’s pediatric care.',
  buttons: [continueButton],
};

export const appWelcomeInterstitial: InterstitialContent = {
  name: 'app-welcome',
  header: 'Welcome back',
  body: 'Tap continue to head to your care hub.',
  buttons: [continueButton],
};

export const onboardingIntroInterstitial: InterstitialContent = {
  name: 'onboarding-intro',
  header: 'Let’s get you set up',
  body: 'A few quick steps to set up your account so we can connect you with care.',
  buttons: [
    {
      displayText: 'Get started',
      url: '/onboarding/add-address',
      color: 'primary',
    },
  ],
};

export const onboardingCompleteInterstitial: InterstitialContent = {
  name: 'onboarding-complete',
  header: 'You’re all set!',
  body: 'Your account is ready. You can now reach our doctors anytime.',
  buttons: [
    {
      displayText: 'Go to home',
      url: '/home',
      color: 'primary',
    },
  ],
};

export const interstitials: Record<string, InterstitialContent> = {
  '4elDCueqBlfWxAhfbg5YCt': appUnregisteredInterstitial,
  sFlODfF8PpBwnLUAvqfGE: signupWelcomeInterstitial,
  '4iuzdDwUQIwxBvRBYp8KXX': signupWelcomeInviteInterstitial,
  '3CA7eKcJFKsXcXj357NBk6': appWelcomeInterstitial,
  Y3cWqi6X44mQYTAGknC6c: onboardingIntroInterstitial,
  '325NKeUm4Is6idEiU5xrzn': onboardingCompleteInterstitial,
};

export const interstitialGroups: Record<string, InterstitialContent[]> = {
  '325NKeUm4Is6idEiU5xrzn': [onboardingCompleteInterstitial],
};
